<div class="card">
    <div
        class="card-header d-flex justify-content-between align-items-center"
        data-testid="accordion-section-header"
        (click)="toggleAccordion($event)"
        [ngClass]="{ 'card-invalid': accordionInvalid }"
    >
        <div class="d-flex align-items-center">
            @if (open) {
                <fa-icon [icon]="faChevronDown" size="lg"></fa-icon>
            }
            @if (!open) {
                <fa-icon [icon]="faChevronRight" size="lg"></fa-icon>
            }
            @if (displayStatusIcon) {
                @if (accordionInvalid) {
                    <fa-icon
                        [icon]="faTimesCircle"
                        size="lg"
                        class="status-icon"
                        data-testid="accordion-section-status-invalid"
                    ></fa-icon>
                }
                @if ((!isUnknownStatusAllowed || accordionOpened) && !accordionInvalid) {
                    <fa-icon
                        [icon]="faCheckCircle"
                        size="lg"
                        class="status-icon valid"
                        data-testid="accordion-section-status-valid"
                    ></fa-icon>
                }
                @if (isUnknownStatusAllowed && !accordionOpened && !accordionInvalid) {
                    <fa-icon
                        [icon]="faQuestionCircle"
                        size="lg"
                        class="status-icon"
                        data-testid="accordion-section-status-invalid"
                    ></fa-icon>
                }
            }
            <h4 class="ps-2 pt-1">
                <ng-content select="[sectionHeader]"></ng-content>
            </h4>
        </div>
        @if (showDataAvailabilityStatus && hasData) {
            <fa-icon [icon]="faCircle" size="xs" class="status-icon"></fa-icon>
        }
    </div>
    @if (open) {
        <div class="card-body" data-testid="accordion-section-body">
            <ng-content select="[sectionBody]"></ng-content>
            @if (allowCollapse) {
                <div class="close-container">
                    <button class="btn btn-link" type="button" (click)="toggleAccordion($event)">
                        <ng-content select="[closeButton]"></ng-content>
                    </button>
                </div>
            }
        </div>
    }
</div>
